// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mastheadPanel-module_root_PzUt3tT8SwNOxr4Sme4X{padding-top:30px}", "",{"version":3,"sources":["webpack://./src/bloks/panels/mastheadPanel/mastheadPanel.module.scss"],"names":[],"mappings":"AACA,gDACI,gBAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~@crunchyroll/cx-web-themes/crunchyroll/abstracts/main\";\n.root {\n    padding-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "mastheadPanel-module_root_PzUt3tT8SwNOxr4Sme4X"
};
export default ___CSS_LOADER_EXPORT___;
